import { render, staticRenderFns } from "./FbLogin.vue?vue&type=template&id=482aa007&scoped=true"
import script from "./FbLogin.vue?vue&type=script&lang=js"
export * from "./FbLogin.vue?vue&type=script&lang=js"
import style0 from "./FbLogin.vue?vue&type=style&index=0&id=482aa007&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482aa007",
  null
  
)

export default component.exports